export default "__VITE_ASSET__CIP9Rnmp__"